module.exports = __webpack_public_path__ + "img/team-4.1ffabe1d.png";